import React from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { DndProvider } from 'react-dnd';
import { useDropzone, FileRejection, DropEvent, Accept } from 'react-dropzone';

const getBackend = () => {
  if (typeof window !== 'undefined' && 'ontouchstart' in window) {
    return TouchBackend;
  }
  return HTML5Backend;
};

interface DropAreaProps {
  label: string;
  document?: string;
  override?: boolean;
  onDrop?: <T extends File>(
    acceptedFiles: T[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void;
  accept?: Accept;
  className?: string;
}

export default function DropArea({
  label,
  document,
  override = false,
  className = '',
  onDrop,
  accept,
}: DropAreaProps) {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
  });
  return (
    <DndProvider backend={getBackend()}>
      <p className="text-neutral-500 text-[14px]">{label}</p>
      <div
        {...getRootProps()}
        role="button"
        className={`mt-4 w-full text-[20px] text-neutral-500 p-2 lg:p-6 h-24 bg-[#F2F2F2] rounded-[5px] ${className}`}
        style={{
          border: '1px dashed #004F9F',
        }}
      >
        <input className="dropzone-input" {...getInputProps()} />
        <p className="text-center">
          {override ? label : `Drop or click to upload ${document || label}`}
        </p>
      </div>
      <p className="text-xs text-red-400 mb-1">
        Uploading document may use large amount of network, be sure to use a
        stable connection.
      </p>
    </DndProvider>
  );
}
